/* @flow weak */
import { ActionTypes } from '../constants/PaymentSourceConstants';
import PaymentSources from 'collections/PaymentSources';

export const initialState = {
  paymentSources: new PaymentSources(),
};

export function reducer(state = initialState, action) {
  let paymentSources;

  switch (action.type) {
    case ActionTypes.DELETE_PAYMENT_SOURCE:
      paymentSources = state.paymentSources.clone();
      paymentSources.remove(action.paymentSource);
      return { ...state, paymentSources };

    case ActionTypes.CREATE_PAYMENT_SOURCE:
      paymentSources = state.paymentSources.clone();
      paymentSources.add(action.paymentSource);
      return { ...state, paymentSources };

    case ActionTypes.LOAD_PAYMENT_SOURCES:
      paymentSources = state.paymentSources.clone();
      paymentSources.add(action.paymentSources.models);
      return { ...state, paymentSources };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/PaymentSources.js